import { ICON_TYPE } from '../component/base/onboard-dialog-dynamic-component/OnboardDialogDynamic';

export const dialogMaxConcurrentSessionLimitIsReached = (setDialogDynamic, t, data, navigate, setLoading) => {
    setDialogDynamic({
        visible: true,
        icon: ICON_TYPE.ERROR,
        title: t('error.max_concurrent_session_limit_title'),
        content: t('error.max_concurrent_session_limit'),
        directingCancel: true,
        confirm: {
            label: t('logout'), click: (setState) => {
                setState({visible: false});
                setLoading(true);
            }
        },
    });
}

export const dialogUserIdExistsWithDifferentIp = (setDialogDynamic, t, navigate) => {
    setDialogDynamic({
        visible: true,
        icon: ICON_TYPE.ERROR,
        title: t('error.user_id_exists_with_different_ip_title'),
        content: t('error.user_id_exists_with_different_ip'),
        directingCancel: true,
        confirm: {
            label: t('okay'), click: (setState) => {
                setState({visible: false});
                if (navigate !== undefined)
                    navigate("/login");
            }
        },
    });
}

export const dialogInternetAccessProblem = (setDialogDynamic, t, navigate) => {
    setDialogDynamic({
        visible: true,
        icon: ICON_TYPE.ERROR,
        title: t('error.internet_connection_failed'),
        content: t('error.user_id_exists_with_different_ip'),
        directingCancel: true,
        confirm: {
            label: t('okay'), click: (setState) => {
                setState({visible: false});
                if (navigate !== undefined)
                    navigate("/login");
            }
        },
    });
}

export const againRequestAccessInternetPopup = (setDialogDynamic, t) => {
    setDialogDynamic({
        visible: true,
        icon: ICON_TYPE.ERROR,
        title: t('error.internet_connection_failed'),
        content: t('error.an_unknown_error'),
        confirm: {
            label: t('okay'), click: (setState) => {
                setState({visible: false});
            }
        }
    });
}

export const dialogScratchCardLoginFailed = (setDialogDynamic, t) => {
    setDialogDynamic({
        visible: true,
        icon: ICON_TYPE.ERROR,
        title: t('error.login_other_username_pass_failed'),
        content: t('error.passenger_not_found'),
        confirm: {
            label: t('error.try_again'), click: (setState) => {
                setState({visible: false});
            }
        }
    });
}
